<template>
  <div>
    <v-btn v-if="isFullScreenMode" @click="markFullScreenMode(false)" class="exit-fullscreen-btn" color="success">
      <v-icon small>mdi-fullscreen-exit</v-icon>
      {{  $t('watch.screen.page.exit.full.screen') }}
    </v-btn>
    <v-layout row wrap :class="{'my-4' : !isFullScreenMode}">
      <v-flex xs12>
        <v-container ma-0 :pa-0="isFullScreenMode" fluid>
          <iframe :src="setCookieUrl" v-show="false"></iframe>
          <v-card height="100%" fill-height v-if="screener" flat class="background">
            <!-- Screener Header -->
            <ScreenerHeader
              v-if="!isFullScreenMode"
              :showBeInRegister="true"
              :screener="screener"
              :screeningStarted="streaming_starts"
            ></ScreenerHeader>
            <!-- For live support notification -->
            <vue-snotify ></vue-snotify>
            <!-- Event manager -->
            <EventManager
              :screener.sync="screener"
              :company="company"
              :isEmbedMode="isEmbedMode"
              :isFullScreenMode="isFullScreenMode"
              :previewMode="isPreviewMode"
              :isVodEvent="screener.is_vod_event"
              :isLoggedInWithLink="isLoggedInWithLink"
              @addToCal="onAddToCal"
              @leaveScreening="leaveScreening()"
            ></EventManager>

            <v-divider
              v-if="screener.qa_info && screener.qa_info.title && screener.qa_info.zoom_link"
              class="primary divider-custom-height"
            ></v-divider>
            <!-- Zoom info -->
            <!-- <ZoomInfo :screener="screener"></ZoomInfo> -->
          </v-card>
          <!-- <Analytics
            ref="analytics"
            :screener="screener"
            :currentTime="currentTime"
            :currentFilmIndex="currentFilmIndex"
          ></Analytics> -->
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import ScreenerHeader from "@/components/screener/Header";
import ZoomInfo from "@/components/screener/Zoom";
import { mapState, mapGetters } from "vuex";
import { getSetCookieUrl } from "@/api/_manager";
import { mapFields } from "vuex-map-fields";
import { getAddToCalLink } from "@/helpers";
import EventManager from "@/components/screener/EventManager/EventManagerRoot";
import FilmPlaylist from "./FilmPlaylist";
import { chromeCast } from "@/mixins/chromeCast.js";
import { firebaseDatabase } from "@/mixins/firebase-database.js";
import i18n from "@/i18n";
import Analytics from "@/components/screener/Analytics";

export default {
  name: "ScreenerWatch",
  metaInfo() {
    if (this.screener) {
      return {
        title: this.screener.title,
      };
    }
  },

  data() {
    return {
      screener: null,
      streaming_starts: false,
      streaming_ended: false,
      setCookieUrl: getSetCookieUrl(this.$route.params.screener_id),
      consumerId: this.$store.state.consumer.profile.id,
      gChromeCast: {
        castSession: null,
        mediaInfo: null,
      },
      routeScreenerId : null
    };
  },

  mixins: [chromeCast, firebaseDatabase],

  components: {
    ScreenerHeader,
    ZoomInfo,
    FilmPlaylist,
    Analytics,
    EventManager,
  },

  computed: {
    ...mapFields("app", {
      currentTime: "currentTime",
      currentScreenerId: "currentScreenerId",
      currentFilmIndex: "currentFilmIndex",
    }),
    ...mapGetters("auth", {
      isPreviewMode: "isPreviewMode",
      isLoggedInWithLink: "isLoggedInWithLink",
    }),
    ...mapGetters("consumer", {
      isVodEventExpired: "isVodEventExpired",
      loggedInConsumer: "getConsumer",
      isConsumerSubscribed: "isSubscribed",
    }),
    ...mapState({
      company: (state) => state.company.company
    }),
    addToCalLink() {
      return getAddToCalLink(this.screener);
    },
    isEmbedMode() {
      return this.$route.query.allowEmbed ? this.$route.query.allowEmbed === 'true': false
    },
    isFullScreenMode: {
      get() {
        return this.$store.state.app.app.isFullScreenMode;
      },
      set(value) {
        this.markFullScreenMode(value);
      }
    }
  },

  created() {
    this.routeScreenerId = this.$route.params.screener_id;
    this.manageConsumerLifecycle(this.routeScreenerId, this.loggedInConsumer.id);
    this.bindLiveConsumersWithFBase(this.routeScreenerId);
  },
  mounted() {
    this.getScreenerWithoutEnforceFromApi();
    this.bindScreenerNotificationsWithFB(this.$route.params.screener_id);
  },

  beforeDestroy() {
    // Unbind Firebase listener
    this.firebase.database().ref(`screener_notifications/${this.routeScreenerId}/`).off('child_added');
    this.updateActiveConsumerCounter("MemberRemoved");
    this.$store.dispatch("chatroom/updateMemberStatus", false)
  },

  methods: {


    checkIsScreenerOver() {
      if (this.isPreviewMode) {
        return;
      }
      if (this.screener) {
        let screenerTotalEndTime = this.moment
          .utc(this.screener.screening_starts_at)
          .add(this.screener.screening_tolerance, "minutes")
          .local()
          .format();
        let currentTime = this.moment().local().format();
        if (currentTime > screenerTotalEndTime) {
          this.streaming_starts = false;
          this.streaming_ended = true;
          this.$store.dispatch("app/showMessage", {
            message: this.$t('screener/event_is_ended'),
            color: "error",
          });
          this.$router.push({ name: "user.dashboard" });
        }
      }
    },
    leaveScreening() {
      try {
        let isAnonymousUser = this.isPreviewMode || this.isLoggedInWithLink;

        if (isAnonymousUser) {
          this.$store.dispatch("auth/logout", {});
        } else {
          /*
            Opening a new tab & accessing watch page by direct URL makes history length 2 (New tab + Watch page)
            In this case, leaveing an event will redirect to previous new tab,
            that's why history length should be greater than 2.
          */
          /* If history is not empty, go back else Redirect to ORG homepage */
          // window.history.length > 2
          //   ? this.$router.go(-1)
          //   : this.goToCompanyDashboard();
        }

        // this.$store.dispatch("app/showMessage", {
        //   message: this.$t("screener.watch.leave_screening"),
        //   color: "success",
        // });

        this.showThankYouPage();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    showThankYouPage()
    {
      // Define the route you want to navigate to
      const routePath = '/thank-you';

      // Use router.push with a target attribute '_blank' to open in a new tab
      // Note: This approach may not work in all browsers due to pop-up blocker restrictions
      window.open(this.$router.resolve(routePath).href, '_blank');
    },

    async getScreenerWithoutEnforceFromApi() {

        await this.$store.dispatch("screening/getWithoutEnforce",{
            id: this.routeScreenerId,
        })
        .then((response) => {
          this.screener = response.screener;
          this.handelEventConfiguration();
          this.checkIsScreenerOver();
          if (this.screener.is_vod_event && !this.isConsumerSubscribed) {
            this.enforceVodSchedule(this.screener);
          }
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });

          //Fixme:: Handel it to server side
          // IMP: if not enrolled and came on this page
          if ((error.code = this.DEFINES.ERROR_TYPE.NOT_ENROLLED_IN_SCREENING)) {
            this.goToScreenerOverview();
          } else {
            this.goToCompanyDashboard();
          }
        });
    },

    goToCompanyDashboard() {
      this.$router.push({
        name: "company.dashboard",
      });
    },

    goToScreenerOverview() {
      this.$router.push({
        name: "screeners.overview",
        params: {
          screener_id: this.$route.params.screener_id,
        },
      });
    },

    async onFirstWatch() {
      await this.$store
        .dispatch("screening/markFirstWatch", {
          screener_id: this.$route.params.screener_id,
        })
        .then((response) => {
          this.getScreenerWithoutEnforceFromApi();
          /**
           * Starting the player
           * 1. Why onFinish()? => onFinish is trigger point for player
           * 2. FIXME: Nomencleture of onFinish can me improved
           */
          this.onFinish();
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    enforceVodSchedule(screener) {
      if (!this.isPreviewMode && this.isVodEventExpired(screener.id)) {
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("vod.player.event.expired"),
          color: "error",
        });
        this.goToScreenerOverview();
      }
    },

    handleCastMuteUnmute(muted) {
      var player = new cast.framework.RemotePlayer();
      var playerController = new cast.framework.RemotePlayerController(player);
      if (player.isMuted) {
        playerController.muteOrUnmute();
        return;
      }

      if (!player.isMuted) {
        playerController.muteOrUnmute();
        return;
      }
    },

    onAddToCal() {
      window.open(this.addToCalLink, "_blank");
    },

    /**
     * Show Screener level notifications with firebase
     */
    bindScreenerNotificationsWithFB(screenerId) {
      let _this = this;
      /**
       * We store pushed notifications on firebase and to show the latest
       * notifications we have used the current timestamp. Here Firebase child key represent
       * the timestamp when the notification was pushed and we are matching this timestamp with
       * current timestamp
       */
      let currentTimeStamp = Math.round(Date.now()/1000);
      this.firebase.database().ref(`screener_notifications/${screenerId}/`).on('child_added',function(snapshot) {
       if(snapshot.key > currentTimeStamp){
         let payload = snapshot.val();
          _this.$store.dispatch("app/showSupportNotification", {
            screener_id: screenerId,
            message: payload.message
          });
       }
      })
    },
    async handelEventConfiguration() {
      /**
       * Handel full screen mode
       */
       if (this.screener.event_configuration.is_full_screen_mode) {
        await this.markFullScreenMode(this.screener.event_configuration.is_full_screen_mode);
      }
    },
    async markFullScreenMode(value) {
      await this.$store.dispatch("app/setFullScreenMode", value);
    },
  },
};
</script>
<style>
#vimeo-video {
  width: 100%;
  height: 75vh;
}
.exit-fullscreen-btn {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 50;
  height: auto;
  margin: 0;
  font-size: xx-small !important;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.exit-fullscreen-btn:hover {
  position: absolute;
}
</style>
